import { api } from "../store/middleware/api";

const extendedApi = api.injectEndpoints({
  endpoints: (build) => ({
    addAddress: build.mutation({
      query: (body) => ({
        url: `/auth/address/add`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["User"],
    }),
    updateAddress: build.mutation({
      query: (body) => ({
        url: `/auth/address/update`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["User"],
    }),
    deleteAddress: build.mutation({
      query: (body) => ({
        url: "/auth/address/delete",
        method: "POST",
        body,
      }),
      invalidatesTags: ["User"],
    }),
    updateProfile: build.mutation({
      query: (body) => ({
        url: "/auth/update",
        method: "POST",
        body,
      }),
      invalidatesTags: ["User"],
    }),
    getUser: build.query({
      query: () => "/auth/dash",
      providesTags: ["User"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useAddAddressMutation,
  useDeleteAddressMutation,
  useUpdateAddressMutation,
  useUpdateProfileMutation,
  useGetUserQuery,
} = extendedApi;
